import api from 'api/apiInstance';

export function clientsUnfollowAllApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
